/**
 * URL の NPS アンケートトークン (`/nps/{npsToken}`) を RPC 呼び出し側 (interceptor) へ
 * 受け渡すための一時保持モジュール (reservationToken.ts と同方式)。
 *
 * アンケート画面は来店確定後のアンケート依頼メールのリンクから開くため案件アクセストークンを
 * 持たず、URL の npsToken だけが GetNPSContext / SubmitNPSAnswer の認可の根拠になる (§6.7)。
 * ルーティング側 (NPSTokenLayout) が URL パラメータに合わせて `setNPSToken` を呼び、
 * npsTokenInterceptor が呼び出しのたびに `getNPSToken` を評価してヘッダへ反映する。
 */
let currentNPSToken: string | undefined;

export function setNPSToken(token: string | undefined): void {
  currentNPSToken = token;
}

export function getNPSToken(): string | undefined {
  return currentNPSToken;
}
